import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import { runtimeActions, runtimeSelectors } from '@blaze-runtime/engine-data-access';
import { CanvasElementId } from '@blaze-runtime/engine-domain';
import { RenderElementContext, RenderElementDataRowContext } from '@blaze-shared/elements-domain';

@Injectable({
  providedIn: 'root',
})
export class RenderElementContextService {
  private store = inject(Store);

  get(
    elementId: CanvasElementId | undefined,
    rowContext?: RenderElementDataRowContext,
  ): Observable<RenderElementContext | undefined> {
    if (!elementId) {
      console.error(`ElementContextService: element info missing`);
      return of(undefined);
    }
    return this.store.select(runtimeSelectors.selectRenderElementContext(elementId, rowContext));
  }

  set(elementId: CanvasElementId, context: RenderElementContext | undefined): void {
    this.store.dispatch(runtimeActions.setRenderElementContext({ elementId, context }));
  }

  clear(elementId: CanvasElementId | undefined, rowContext?: RenderElementDataRowContext): void {
    if (!elementId) {
      return;
    }

    this.store.dispatch(runtimeActions.clearRenderElementContext({ elementId, rowContext }));
  }
}
